/**
 * Paths used by `Viewing Pos Device` feature. Allows in example conditionally redirection.
 */
export const CARD_PAYMENT_PATHS = ['card-payment'];
